export const useIsMobileStore = definePiniaStore('isMobile', () => {
    const value = ref(false)
    
    return {
        value
    }
})
